import styled from 'styled-components'

export const CheckListContainer = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	width: 100%;
	height: ${props => props.$height || 'auto'};
	overflow-y: scroll;
	padding-right: 4px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		height: auto;
		overflow-y: auto;
	}
`

export const CheckListItem = styled.li`
	padding: 6px 8px;
	cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
	border-radius: 8px;
	color: ${props => props.$disabled ? props.theme.colors.text.disabledText : props.theme.colors.text.primaryText};
	opacity: ${props => props.$disabled ? 0.4 : 1};

	&:hover {
		background-color: ${props => props.$disabled ? 'transparent' : props.theme.colors.brand.backgroundBlue};
	}
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		padding: 8px 14px 8px 0;
	}
`

export const CheckListItemContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
	position: absolute;
	opacity: 0;
	pointer-events: none;
	height: 0;
	width: 0;
`

export const StyledCheckbox = styled.div`
	width: 18px;
	height: 18px;
	border: 2px solid;
	border-color: ${props => props.$disabled ? props.theme.colors.text.disabledText : props.theme.colors.brand.blueOmint};
	border-radius: 4px;
	background-color: ${props =>
		props.$checked ? props.theme.colors.brand.blueOmint : props.theme.colors.brand.white};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`